import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  tracesSampleRate: 0,
  // A promise rejected with literally nothing, with no stack frames, comes from code outside our bundle
  // (browser extensions, Safari/Edge injected scripts). Kept narrow so real non-Error rejections still report.
  ignoreErrors: [/^Non-Error promise rejection captured with value: undefined$/],
  // Drop events whose frames originate from a browser extension.
  denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-(web-)?extension:\/\//],
});


export class SentryTest {
  static setup() {
    const sentryTest = document.querySelector('[href="/sentry_tests/new"]');
    if (sentryTest) {
      sentryTest.addEventListener('click', function () {
        setTimeout(() => {
          throw new Error('Sentry Test Error (JS)');
        });
      });
    }
  }
}
